import React from 'react'
import CustomContainer from '../../components/common/CustomContainer'
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, LabelList } from "recharts";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid } from "recharts";

const pieData = [
    { name: "High Risk", value: 45.8, color: "#d62728" },
    { name: "Moderate risk", value: 45.8, color: "#ff7f0e" },
    { name: "Normal", value: 8.4, color: "#2ca02c" },
];
const data = [
    { name: "Government", value: 89 },
    { name: "Nonprofit", value: 57 },
    { name: "Foundation", value: 37 },
    { name: "Consulting", value: 28 },
    { name: "Other", value: 19 },
];
const TestResult = () => {
    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>Test result</h2>
                </div>

                <div className={`grid grid-cols-1 md:grid-cols-2 md:gap-6 gap-y-6 mt-6`}>
                    <div className='bg-white shadow-lg rounded-lg p-4'>
                        <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                                <Pie
                                    data={pieData}
                                    label
                                    outerRadius={100}
                                    fill="#8884d8"
                                    dataKey="value"
                                    className="PieChartStyle"
                                >
                                    {pieData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                <Tooltip />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <div className='bg-white shadow-lg rounded-lg p-4'>
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                                layout="vertical"
                                data={data}
                                margin={{ top: 20, right: 40, left: 80, bottom: 10 }} // More left space
                            >
                                <CartesianGrid strokeDasharray="3 3" horizontal={false} />
                                <XAxis type="number" />
                                <YAxis dataKey="name" type="category" width={100} />
                                <Tooltip />
                                <Bar dataKey="value" fill="#9c27b0" barSize={30} radius={[5, 5, 0, 0]}>
                                    <LabelList dataKey="value" position="right" fill="#000" fontSize={12} />
                                </Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </CustomContainer>
    )
}

export default TestResult